var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner24 = function SvgSpinner24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.16,
    d: "M19.6 12a7.6 7.6 0 1 1-15.198 0A7.6 7.6 0 0 1 19.6 12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#275CDE",
    d: "M12 4.4A7.6 7.6 0 1 1 4.4 12"
  }))));
};
export default SvgSpinner24;